<template>
  <div id="app">
    <div :class="isMob ? 'transform-90' : 'wd-100p ht-100p'">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
* {
  margin: 0px;
  padding: 0px;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>

<script>
export default {
  name: "App",
  metaInfo() {
    return {
      title:
        this.$store.state.settings.dynamicTitle &&
        this.$store.state.settings.title,
      titleTemplate: (title) => {
        return title
          ? `${title} - ${process.env.VUE_APP_TITLE}`
          : process.env.VUE_APP_TITLE;
      },
    };
  },
  data() {
    return {
      isMob: false,
      src:require('@/assets/Rotatedevice.png')
    };
  },
  mounted() {
    let self = this; // 这里
    let isMob = /Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(
      navigator.userAgent
    );
    // if (window.orientation == 0 && isMob) {
    //   this.$Modal.confirm({
    //     // title: "Confirmation",
    //     content: "<img class='wd-80p' src="+ this.src+" />",
    //     okText: "Confirm",
    //     cancelText: "Cancel",
    //     onOk: () => {
    //       this.isMob = isMob;
    //     },
    //     onCancel: () => {
    //       this.isMob = isMob;
    //     },
    //   });
    // }
    // window.addEventListener(
    //   "onorientationchange" in window ? "orientationchange" : "resize",
    //   function() {
    //     console.log(window.orientation)
    //     if (window.orientation === 0 || window.orientation === -180 || window.orientation === 180) {
    //       self.$msgbox("建议横屏操作！");
    //     }
    //     //window.location.reload();
    //   });
  },
};
</script>

